export enum ImageSize {
  SMALL = 'small',
  LARGE = 'large',
}

export enum ClubPromoImageSize {
  SMALL = 'small',
  NORMAL = 'normal',
}
